import './lakemoreyresort/style';
import FormStructure from './lakemoreyresort/form_structure';

export default FormStructure;